/**
 * Formats a number to Indian price format with commas and trailing '/-'
 * Example: 14842.5 -> '14,842.5/-'
 *
 * @param amt - Number or numeric string to format
 * @param maximumFractionDigits - Maximum fraction digits (defaults to 4)
 * @returns Formatted price string
 */
export const formatPrice = (
  amt: number | string | undefined | null,
  maximumFractionDigits: number = 4
): string => {
  if (amt === undefined || amt === null || isNaN(Number(amt))) return "0/-";
  const cleanAmt = parseFloat(Number(amt).toFixed(maximumFractionDigits));
  return `${cleanAmt.toLocaleString("en-IN", { maximumFractionDigits })}/-`;
};

export default formatPrice;
